import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { CheckCircleOutline, ClockOutline, Reload } from 'mdi-material-ui';
const StatusIndicator = ({ plan }) => {
    const { approved, remarks } = plan;
    let colorValue, icon, text;
    colorValue = approved
        ? 'success.main'
        : remarks
            ? 'error.main'
            : 'warning.main';
    icon = approved ? (_jsx(CheckCircleOutline, { sx: { fontSize: 16, marginRight: 1 } })) : remarks ? (_jsx(Reload, { sx: { fontSize: 16, marginRight: 1 } })) : (_jsx(ClockOutline, { sx: { fontSize: 16, marginRight: 1 } }));
    text = approved
        ? 'Approved'
        : remarks
            ? 'Changes Required'
            : 'Awaiting Approval';
    return (_jsxs(Stack, Object.assign({ direction: "row", sx: {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '4px 12px',
            border: 1,
            borderColor: colorValue,
            color: colorValue,
            fontWeight: '400',
            borderRadius: '4px',
        } }, { children: [icon, _jsx(Typography, Object.assign({ fontSize: "14px", color: colorValue }, { children: text }))] })));
};
export default StatusIndicator;
